// Vendor polyfills
import 'core-js/shim';
import 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'intl/locale-data/jsonp/fr.js';

// Vendor
import * as React from 'react';
import {render} from 'react-dom';

// Components
import Application from 'isee/ui/application';

// Vendor CSS
import 'react-calendar/dist/Calendar.css';

// CSS
import 'isee/ui/styles/calendar-override.css';
import 'isee/ui/styles/ie-override.css';
import 'isee/ui/styles/stripe-connect-button.css';
import 'isee/ui/styles/stripe-elements-override.css';

render(<Application />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx